module.exports = __webpack_public_path__ + "static/media/Icon metro-cross.9f676efa.svg";